<form class="page-container flex flex-column" (validate)="save()" novalidate validation-es>
  <h2>{{screen.labels.doctorHeading}}</h2>

  <ms-common-person-form name="personForm" [(ngModel)]="person"></ms-common-person-form>

  <hr>

  <ms-common-doctor-form name="doctorModel" [(ngModel)]="doctor"></ms-common-doctor-form>

  <hr>

  <div class="align-self-end">
    <button pButton [type]="infoSave ? 'button' : 'submit'"
      [label]="infoSave ? screen.actions.saving : screen.actions.save" [icon]="infoSave ? loadingIcon : 'far fa-save'"
      class="p-button-success p-button-outlined"></button>
  </div>
</form>

<hr>

<form class="page-container flex flex-column" (validate)="updatePass()" novalidate validation-es>
  <div class="col-12 p-0 align-items-center form__field flex-column md:flex-row">
    <label class="col-12 md:col-4 p-0 md:m-0" for="password">{{screen.labels.passwordHeading}}</label>
    <div class="col-12 md:col-8 p-0 inline-flex">
      <input pInputText type="password" pPassword name="password" [(ngModel)]="password" autocomplete="off" validation
        [required]="true" class="m-0" />
    </div>
  </div>

  <div class="col-12 p-0 align-items-center form__field flex-column md:flex-row">
    <label class="col-12 md:col-4 p-0 md:m-0" for="passwordVerify">{{screen.labels.passwordVerify}}</label>
    <div class="col-12 md:col-8 p-0 inline-flex">
      <input pInputText type="password" pPassword name="passwordVerify" [(ngModel)]="passwordVerify" autocomplete="off"
        validation [equalTo]="password" />
    </div>
  </div>

  <div class="align-self-end">
    <button pButton [type]="passSave ? 'button' : 'submit'"
      [label]="passSave ? screen.actions.saving : screen.actions.updatePass"
      [icon]="passSave ? loadingIcon : 'far fa-save'" class="p-button-success p-button-outlined"></button>
  </div>
</form>